import PropTypes from 'prop-types';

import {OEManualViewPropTypes} from '../../manual-view/oe-manual-view-model';

export const OEFNHelpEntryType = {
    spacer:                             'spacer',
    text:                               'text',
    email:                              'email',
    website:                            'website',
    advice:                             'advice',
    manual:                             'manual',
    manualInteractive:                  'manualInteractive',
    quickStart:                         'quickStart',
    videoTutorials:                     'videoTutorials',
    tutorReset:                         'tutorReset',
    disableTutor:                       'disableTutor',
    usageRights:                        'usageRights',
    licenseAgreement:                   'licenseAgreement',
    credits:                            'credits',
    feedback:                           'feedback',
    version:                            'version',
    flowNavElementCollection:           'flowNavElementCollection'
};

OEFNHelpEntryType.all = Object.values(OEFNHelpEntryType);

//
export const OEFNHelpPropTypes = {

    entry: PropTypes.shape({
        type:                           PropTypes.oneOf(OEFNHelpEntryType.all).isRequired,
        link:                           PropTypes.string,
        linkId:                         PropTypes.string,
        viewTitle:                      PropTypes.string,
        viewTitleId:                    PropTypes.string,
        className:                      PropTypes.string,
        string:                         PropTypes.string,
        stringId:                       PropTypes.string,
        icon:                           PropTypes.string,
        height:                         PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        spacerHeight:                   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        mask: PropTypes.shape({
            licenseValid:               PropTypes.bool,
            licensingAccess:            PropTypes.func
        }),
        elements:                       PropTypes.array     // -> flowNavElementCollection elements
    })
};

OEFNHelpPropTypes.entries = PropTypes.arrayOf(OEFNHelpPropTypes.entry);

OEFNHelpPropTypes.propTypes = {
    locStringPrefix:                    PropTypes.string,
    entries:                            OEFNHelpPropTypes.entries,
    manualViewLinks:                    OEManualViewPropTypes.links,
    autoSpacerHeight:                   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    version:                            PropTypes.bool,
    versionForDev:                      PropTypes.bool,
    devFeatures:                        PropTypes.bool,
};

//
export class OEFNHelpEntryFactory {

    constructor(entries, ref = true) {
        this.set(entries, ref);
    }

    set(entries, ref = false)    {      // ref == true -> overwrite reference
        if(!Array.isArray(entries))    {
            if(!ref && this.entries) {
                if(this.entries.length) this.entries.splice(0, this.entries.length);
            } else {
                this.entries = [];
            }
            return this;
        }

        if(ref) {
            this.entries = entries;
        } else {
            if(!Array.isArray(this.entries))    this.entries = [];
            this.entries.splice(0, this.entries.length, ...entries);
        }

        return this;
    }

    build(copy = true)   {
        if(!copy)    return this.entries;
        return clone(this.entries);
    }

    clear() {
        return this.set(undefined, false);
    }

    def()   {
        return this.set(OEFNHelpEntryFactory.buildDef(), false);
    }

    insertEntryAtIndex(index, entry)   {
        if(!Array.isArray(entry))   entry = [entry];
        this.entries.splice(index, 0, ...entry);
        return this;
    }

    addEntry(entry) {
        return this.insertEntryAtIndex(this.entries.length, entry);
    }

    removeEntryAtIndex(index)    {
        this.entries.splice(index, 1);
        return this;
    }

    replaceEntryAtIndex(index, entry)   {
        if(!Array.isArray(button))   entry = [entry];
        this.entries.splice(index, 1, ...entry);
        return this;
    }

    insertEntryRelativeToType(type, offset, entry)  {
        let index = this.entries.findIndex(e => e.type === type);
        if(index < 0)   return this;
        
        if(!Array.isArray(entry))   entry = [entry];
        this.entries.splice(index + offset, 0, ...entry);

        return this;
    }

    insertEntryAfterType(type, entry) {
        return this.insertEntryRelativeToType(type, 1, entry);
    }

    insertEntryInFrontOfType(type, entry) {
        return this.insertEntryRelativeToType(type, 0, entry);
    }

    replaceEntryByType(type, entry) {
        let index = this.entries.findIndex(e => e.type === type);
        if(index < 0)   return this;

        if(!Array.isArray(entry))   entry = [entry];
        this.entries.splice(index, 1, ...entry);

        return this;
    }

    removeEntryByType(type, fn)  {
        let types = Array.isArray(type) ? type : [type];
        this.entries.splice(0, this.entries.length, ...this.entries.filter(e => !(types.includes(e.type) && (!fn || fn(e)))));
        return this;
    }

    modifyEntryByType(type, fn)    {
        if(!fn) return this;

        this.entries.forEach(e => {
            if(e.type !== type)   return;
            fn(e);
        });

        return this;
    }
};

OEFNHelpEntryFactory.buildDef = function()  {
    return [
        {type: OEFNHelpEntryType.spacer, height: '4.625em' /*74*/},
        {type: OEFNHelpEntryType.advice},
        {type: OEFNHelpEntryType.quickStart},
        {type: OEFNHelpEntryType.tutorReset},
        {type: OEFNHelpEntryType.disableTutor},
        {type: OEFNHelpEntryType.spacer, height: '1.875em' /*30*/},
    ];
};

OEFNHelpEntryFactory.buildDefInfoHelp = function()  {
    return [
        {type: OEFNHelpEntryType.spacer, height: '4.625em' /*74*/},
        {type: OEFNHelpEntryType.usageRights},
        {type: OEFNHelpEntryType.licenseAgreement},
        {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
        {type: OEFNHelpEntryType.credits},
        {type: OEFNHelpEntryType.feedback},
    ];
};